module.exports = __webpack_public_path__ + "fonts/lineto-circular-pro-black.ff9a612.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/CircularPro/lineto-circular-pro-black.woff
// module id = 148
// module chunks = 245 246